// extracted by mini-css-extract-plugin
export var equalColumn = "_hw-0";